import { createAction } from 'typesafe-actions';
import { ContainerTypeLegacy } from '../util/constant';

// intermittent background poll to keep the recommedation chart ui relatively fresh
export const pollBackgroundRecommWindowsState = createAction(
  'POLL/BACKGROUND_RECOMM_WINDOWS_STATE',
  (resolve) => {
    return (payload: { container_id: number | null; container_type: ContainerTypeLegacy | null }) =>
      resolve(payload);
  }
);
